export default {
    // Header Section
    "discover_your": "Discover Your",
    "nature_report": "Character Analysis",
    "natural_personality_insights": "Natural Personality Insights",
    "nature_report_description": "Understand your authentic personality and innate nature through comprehensive analysis. Discover your natural behavior patterns, inherent strengths, core temperament, and authentic self-expression style based on your birth details.",

    // Service Information
    "enter_details_for_nature_analysis": "Enter Your Details for Nature Analysis",
    "complete_nature_analysis": "Complete Nature Analysis",
    "service_price": "Service Price",
    "comprehensive_nature_analysis_note": "Deep analysis of your natural personality and behavioral patterns",

    // Form Fields
    "full_name": "Full Name",
    "enter_full_name": "Enter your full name",
    "name_natural_vibration": "Your name resonates with your natural personality vibrations",
    "email_address": "Email Address",
    "enter_email_address": "Enter your email address",
    "phone_number": "Phone Number",
    "enter_phone_number": "Enter your phone number",
    "gender": "Gender",
    "male": "Male",
    "female": "Female",
    "other": "Other",
    "date_of_birth": "Date of Birth",
    "birth_date_personality_nature": "Essential for determining your natural personality traits and elemental nature",
    "preferred_language": "Preferred Language",
    "english": "English",
    "hindi": "Hindi",
    "telugu": "Telugu",
    "kannada": "Kannada",
    "language_note": "Your nature analysis will be delivered in the selected language",

    // Core Nature Features
    "personality_traits_analysis": "Personality Traits Analysis",
    "behavioral_patterns_insights": "Behavioral Patterns Insights",
    "strengths_weaknesses_profile": "Strengths & Weaknesses Profile",
    "natural_talents_discovery": "Natural Talents Discovery",
    "life_approach_guidance": "Life Approach Guidance",
    "pdf_download": "Comprehensive PDF Report",

    "what_you_get": "What Your Nature Analysis Includes",
    "comprehensive_personality_profile": "Comprehensive Personality Profile",
    "natural_behavior_patterns": "Natural Behavior Patterns",
    "innate_talents_abilities": "Innate Talents & Abilities",
    "personal_growth_guidance": "Personal Growth Guidance",

    // Actions & Buttons
    "pay_and_generate_analysis": "Get My Nature Analysis",
    "processing_payment": "Processing Payment",
    "processing_request": "Generating Analysis",

    // Payment & Success Messages
    "thank_you": "Thank You",
    "payment_successful": "Payment Successful!",
    "nature_analysis_processing": "Your nature analysis is being prepared by our expert personality analysts. You'll receive detailed insights into your natural personality and behavioral patterns.",
    "order_id": "Order ID",
    "payment_id": "Payment ID",
    "amount_paid": "Amount Paid",

    // Delivery Information
    "delivery_information": "Delivery Information",
    "delivery_time": "Analysis Delivery",
    "within_8_hours_delivery_note": "Your detailed nature report will be ready within 8 hours",
    "whatsapp_notification": "WhatsApp Updates",
    "whatsapp_delivery_note": "Receive instant notifications on WhatsApp",
    "email_delivery": "Email Delivery",
    "email_delivery_note": "Complete analysis delivered to",

    // What You'll Receive
    "what_youll_receive": "Your Nature Analysis Package",
    "detailed_nature_report": "Comprehensive Nature Report (PDF)",
    "personality_traits_breakdown": "Personality Traits Breakdown",
    "behavioral_insights_guide": "Behavioral Insights Guide",
    "natural_abilities_assessment": "Natural Abilities Assessment",
    "personal_development_roadmap": "Personal Development Roadmap",

    // Visual Content
    "sample_nature_analysis": "Sample Nature Analysis",
    "dominant_nature_type": "Dominant Nature Type",
    "sample_nature_reading": "Balanced Earth-Fire nature with strong leadership qualities",
    "sample_nature_preview": "Preview of your personalized nature analysis with elemental insights",
    "nature_elements": "Nature Elements",

    // Nature Element Types
    "fire": "Fire",
    "water": "Water",
    "earth": "Earth",
    "air": "Air",
    "ether": "Ether",
    "nature": "Nature",

    // Status & Processing
    "your_nature_analysis_status": "Your Nature Analysis Status",
    "processing_your_analysis": "Analyzing Your Natural Personality",
    "analysis_processing_message": "Our personality experts are studying your birth patterns to determine your authentic nature and behavioral tendencies.",
    "request_id": "Analysis ID",
    "status": "Status",
    "processing": "In Progress",
    "pending": "Queued",
    "email_notification_sent": "Confirmation email sent",
    "whatsapp_update_coming": "WhatsApp updates enabled",
    "delivery_within_8_hours": "Report ready within 8 hours",

    // Support & Contact
    "contact_support": "Contact Nature Support",
    "need_help": "Need guidance?",
    "contact_us_at": "Reach us at",

    // Error Messages
    "please_fill_all_required_fields": "Please complete all required details",
    "payment_failed": "Payment unsuccessful. Please try again.",
    "processing_failed": "Analysis processing failed. Contact our support team.",

    // Nature-Specific Elements
    "elemental_composition": "Elemental Composition",
    "dominant_element": "Dominant Element",
    "secondary_elements": "Secondary Elements",
    "elemental_balance": "Elemental Balance",
    "natural_constitution": "Natural Constitution",
    "temperament_type": "Temperament Type",

    // Personality Traits
    "core_personality_traits": "Core Personality Traits",
    "surface_personality": "Surface Personality",
    "hidden_personality": "Hidden Personality",
    "authentic_self": "Authentic Self",
    "personality_layers": "Personality Layers",
    "character_essence": "Character Essence",

    // Behavioral Patterns
    "natural_reactions": "Natural Reactions",
    "instinctive_responses": "Instinctive Responses",
    "behavioral_tendencies": "Behavioral Tendencies",
    "habitual_patterns": "Habitual Patterns",
    "unconscious_behaviors": "Unconscious Behaviors",
    "automatic_responses": "Automatic Responses",

    // Strengths & Abilities
    "natural_strengths": "Natural Strengths",
    "inherent_abilities": "Inherent Abilities",
    "inborn_talents": "Inborn Talents",
    "natural_gifts": "Natural Gifts",
    "core_competencies": "Core Competencies",
    "instinctive_skills": "Instinctive Skills",

    // Weaknesses & Challenges
    "natural_weaknesses": "Natural Weaknesses",
    "blind_spots": "Personality Blind Spots",
    "growth_areas": "Areas for Growth",
    "challenging_traits": "Challenging Traits",
    "limiting_patterns": "Limiting Patterns",
    "shadow_aspects": "Shadow Aspects",

    // Temperament Types
    "sanguine_nature": "Sanguine Nature",
    "choleric_nature": "Choleric Nature",
    "melancholic_nature": "Melancholic Nature",
    "phlegmatic_nature": "Phlegmatic Nature",
    "mixed_temperament": "Mixed Temperament",
    "temperament_blend": "Temperament Blend",

    // Elemental Natures
    "fire_personality": "Fire Personality",
    "water_personality": "Water Personality",
    "earth_personality": "Earth Personality",
    "air_personality": "Air Personality",
    "space_personality": "Space Personality",
    "elemental_dominance": "Elemental Dominance",

    // Interaction Styles
    "social_nature": "Social Nature",
    "communication_style": "Communication Style",
    "interaction_preferences": "Interaction Preferences",
    "relationship_approach": "Relationship Approach",
    "conflict_style": "Conflict Resolution Style",
    "leadership_nature": "Leadership Nature",

    // Emotional Nature
    "emotional_patterns": "Emotional Patterns",
    "feeling_responses": "Feeling Responses",
    "emotional_expression": "Emotional Expression",
    "mood_tendencies": "Mood Tendencies",
    "emotional_intelligence": "Emotional Intelligence",
    "sensitivity_levels": "Sensitivity Levels",

    // Mental Nature
    "thinking_patterns": "Thinking Patterns",
    "mental_approach": "Mental Approach",
    "cognitive_style": "Cognitive Style",
    "learning_style": "Learning Style",
    "decision_making": "Decision Making Style",
    "problem_solving": "Problem Solving Approach",

    // Physical Nature
    "physical_constitution": "Physical Constitution",
    "energy_patterns": "Energy Patterns",
    "activity_preferences": "Activity Preferences",
    "physical_expressions": "Physical Expressions",
    "body_language": "Natural Body Language",
    "physical_tendencies": "Physical Tendencies",

    // Spiritual Nature
    "spiritual_inclinations": "Spiritual Inclinations",
    "inner_nature": "Inner Nature",
    "soul_expression": "Soul Expression",
    "spiritual_path": "Natural Spiritual Path",
    "divine_connection": "Divine Connection Style",
    "transcendental_nature": "Transcendental Nature",

    // Life Approach
    "life_philosophy": "Natural Life Philosophy",
    "approach_to_challenges": "Approach to Challenges",
    "goal_orientation": "Goal Orientation",
    "success_definition": "Success Definition",
    "life_priorities": "Life Priorities",
    "value_system": "Core Value System",

    // Career Nature
    "work_style": "Natural Work Style",
    "career_preferences": "Career Preferences",
    "professional_nature": "Professional Nature",
    "workplace_behavior": "Workplace Behavior",
    "team_dynamics": "Team Dynamics",
    "professional_growth": "Professional Growth Pattern",

    // Relationship Nature
    "relationship_style": "Relationship Style",
    "love_expression": "Love Expression",
    "friendship_patterns": "Friendship Patterns",
    "family_dynamics": "Family Dynamics",
    "partnership_nature": "Partnership Nature",
    "social_connections": "Social Connections",

    // Growth & Development
    "natural_evolution": "Natural Evolution Path",
    "growth_potential": "Growth Potential",
    "development_areas": "Development Areas",
    "transformation_capacity": "Transformation Capacity",
    "learning_opportunities": "Learning Opportunities",
    "self_improvement": "Self Improvement Areas",

    // Seasonal Nature
    "seasonal_influences": "Seasonal Influences",
    "cyclical_patterns": "Cyclical Patterns",
    "natural_rhythms": "Natural Rhythms",
    "biorhythms": "Personal Biorhythms",
    "energy_cycles": "Energy Cycles",
    "mood_cycles": "Mood Cycles",

    // Environmental Nature
    "environmental_preferences": "Environmental Preferences",
    "natural_habitat": "Natural Habitat",
    "climate_preferences": "Climate Preferences",
    "space_requirements": "Space Requirements",
    "comfort_zones": "Comfort Zones",
    "optimal_environments": "Optimal Environments",

    // Communication Nature
    "expression_style": "Expression Style",
    "listening_style": "Listening Style",
    "verbal_patterns": "Verbal Patterns",
    "non_verbal_communication": "Non-verbal Communication",
    "communication_barriers": "Communication Barriers",
    "effective_communication": "Effective Communication Tips",

    // Stress & Relaxation
    "stress_patterns": "Stress Patterns",
    "stress_responses": "Stress Responses",
    "relaxation_needs": "Relaxation Needs",
    "recovery_methods": "Recovery Methods",
    "self_care_nature": "Self Care Nature",
    "wellness_approaches": "Wellness Approaches",

    // Creative Nature
    "creative_expression": "Creative Expression",
    "artistic_inclinations": "Artistic Inclinations",
    "innovation_style": "Innovation Style",
    "creative_processes": "Creative Processes",
    "inspiration_sources": "Inspiration Sources",
    "creative_blocks": "Creative Blocks & Solutions"
};
